module.exports = __webpack_public_path__ + "static/media/web.762c7110.jpg";